import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import CommentForm from '../comment-form/CommentForm';
import { MdEdit } from 'react-icons/md';
import { updateComment } from '@app/services/tasks';
import handleStatus from '../../utils/ajax';
import { logoutUser } from '@app/store/reducers/auth';
import { toast } from 'react-toastify';

const Comment = ({
  text,
  id,
  isEditable,
  issueId,
  getcomments,
  userName = '',
  created_At
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [commentText, setCommentText] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const projectId = localStorage.getItem('TaskProjectId');
  const goToEditComment = (text: any) => {
    setIsEditing(true);
    setCommentText(text);
  };

  const submitHandler = async (e: any) => {
    e.preventDefault();
    const resp = await updateComment(id, { text: commentText });
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    if (resp && !resp?.data?.ok) {
      toast.error(resp?.data?.message || 'Error while updating comments');
      setIsEditing(false);
      getcomments(issueId, projectId);
      return
    }
    toast.success(resp?.data?.message || 'Comment updating sucessfully');
    setIsEditing(false);
    getcomments(issueId, projectId);
  };

  function getInitials(name) {
    // Split the full name into an array of words
    const nameArray = name.split(' ');

    // Extract the first character from each word (first name and last name)
    const initialsArray = nameArray.map((word) => word.charAt(0));

    // Join the initials and convert to uppercase
    const initials = initialsArray.join('').toUpperCase();

    return initials;
  }

  const formatDate = (timestamp) => {
    // Convert timestamp to Date object
    const date = new Date(timestamp);

    // Define options for formatting
    const options = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    // Format the date
    const formattedDate = format(date, "do MMMM yyyy 'at' h:mm a", options);

    return formattedDate;
  };

  const Preview = () => {
    return (
      <div className="d-flex flex-row" key={id}>
        <span
          className="d-inline-block"
          tabIndex={0}
          data-toggle="tooltip"
          title={userName}
        >
          <p
            style={{ width: '50px', height: '50px' }}
            className="d-flex align-items-center rounded-circle bg-primary text-white justify-content-center"
          >
            {getInitials(userName)}
          </p>
        </span>
        <div
          style={{
            margin: '4px 8px',
            borderRadius: '8px',
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
          }}
          className="p-2 w-100"
        >
          <p className="text-wrap word-wrap my-2 w-100"> {text}</p>
          <span style={{ fontSize: '12px' }} className='d-inline-block w-100 text-right'>{formatDate(created_At)}</span>

          {isEditable && (
            <div className="d-flex align-items-center justify-content-end">
              <span>
                <MdEdit
                  onClick={() => goToEditComment(text, id)}
                  style={{ fontSize: '20px', cursor: 'pointer' }}
                />
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {isEditing ? (
        <CommentForm
          submitHandler={submitHandler}
          commentText={commentText}
          setCommentText={setCommentText}
          setIsEditing={setIsEditing}
          issueId={issueId}
          getcomments={getcomments}
        />
      ) : (
        <Preview />
      )}
    </Fragment>
  );
};

export default Comment;
